export const pagesTicketsEn = {
  add: {
    documentTitle: 'Add Development Ticket',
    errors: {
      required: 'Required'
    },
    fields: {
      assignees: 'Assignees',
      changeAreas: 'Change Areas',
      decisionNote: 'Decision Note',
      dueDate: 'Due Date',
      expectedOutcome: 'Expected Outcome',
      kind: 'Kind',
      priority: 'Priority',
      product: 'Product',
      productionTargetNode: 'Production Target',
      qaImpactNote: 'QA Impact Note',
      riskNote: 'Risk Note',
      severity: 'Severity',
      sprint: 'Sprint',
      status: 'Status',
      summary: 'Summary',
      title: 'Title'
    },
    pageTitle: 'Add Development Ticket',
    placeholders: {
      assigneeSearch: 'Search assignees'
    },
    step1: {
      nextButton: 'Next',
      title: 'Basic Information'
    },
    step2: {
      nextButton: 'Next',
      previousButton: 'Back',
      title: 'Change Content'
    },
    step3: {
      nextButton: 'Create',
      previousButton: 'Back',
      title: 'Priority / Progress / QA'
    },
    stepper: {
      title: 'Sections'
    },
    submitButton: 'Create'
  },
  addSelect: {
    csvBulkUpload: 'Bulk upload via CSV',
    externalSystemSync: 'Sync with external system',
    fillOutDetails: 'Fill out details',
    orLabel: 'Or...',
    pageTitle: 'Add Development Ticket',
    requiredFields: {
      product: 'Product',
      status: 'Status',
      title: 'Title'
    },
    requiredItems: 'Required Items',
    selectionTitle: 'Please select what to add',
    ticketCardTitle: 'Development Ticket'
  },
  detail: {
    actions: {
      changeStatus: 'Change Status'
    },
    breadcrumb: {
      home: 'Home',
      tickets: 'Development Tickets'
    },
    changeStatusDialog: {
      cancel: 'Cancel',
      confirm: 'Change Status',
      description: 'Change the status of "{{name}}" from {{currentStatus}} to a new status.',
      required: 'Required',
      success: 'Status has been changed.',
      title: 'Change Status',
      unsavedWarning: 'You have unsaved changes. Changing the status will discard your edits. Continue?',
      unsavedWarningContinue: 'Continue',
      unsavedWarningTitle: 'Unsaved Changes'
    },
    fields: {
      affectedTestSets: 'Affected Test Sets',
      assignees: 'Assignees',
      changeAreas: 'Change Areas',
      code: 'Code',
      createdAt: 'Created At',
      createdBy: 'Created By',
      decisionNote: 'Decision Note',
      dueDate: 'Due Date',
      expectedOutcome: 'Expected Outcome',
      kind: 'Kind',
      priority: 'Priority',
      product: 'Product',
      qaImpactNote: 'QA Impact Note',
      riskNote: 'Risk Note',
      severity: 'Severity',
      sprint: 'Sprint',
      status: 'Status',
      summary: 'Summary',
      title: 'Title',
      updatedAt: 'Updated At'
    },
    history: {
      empty: 'No history yet',
      eventType: {
        CREATED: 'Created',
        STATUS_CHANGED: 'Status changed',
        UPDATED: 'Updated'
      },
      fieldKey: {
        affectedTestSetIds: 'Affected Test Sets',
        assigneePersonIds: 'Assignees',
        changeAreas: 'Change Areas',
        code: 'Code',
        decisionNote: 'Decision Note',
        dueDate: 'Due Date',
        expectedOutcome: 'Expected Outcome',
        kind: 'Kind',
        priority: 'Priority',
        productId: 'Product',
        productNodeIds: 'Product Scope (Function)',
        qaImpactNote: 'QA Impact Note',
        riskNote: 'Risk Note',
        severity: 'Severity',
        specificationIds: 'Product Scope (Specification)',
        sprint: 'Sprint',
        status: 'Status',
        summary: 'Summary',
        title: 'Title'
      }
    },
    options: {
      ticketKind: {
        BUG_FIX: 'Bug Fix',
        ENHANCEMENT: 'Enhancement',
        NEW_FEATURE: 'New Feature',
        OPS: 'Ops',
        OTHER: 'Other',
        REFACTORING: 'Refactoring',
        RESEARCH: 'Research',
        TECH_DEBT: 'Tech Debt'
      },
      ticketPriority: {
        P0: 'P0',
        P1: 'P1',
        P2: 'P2',
        P3: 'P3'
      },
      ticketSeverity: {
        CRITICAL: 'Critical',
        HIGH: 'High',
        LOW: 'Low',
        MEDIUM: 'Medium'
      },
      ticketStatus: {
        ARCHIVED: 'Archive',
        CLOSED: 'Closed',
        DONE: 'Done',
        IN_PROGRESS: 'In Progress',
        IN_REVIEW: 'In Review',
        OPEN: 'Open'
      }
    },
    pageTitle: 'Development Ticket Detail',
    placeholders: {
      assigneeSearch: 'Search assignees'
    },
    productScope: {
      changeButton: 'Change',
      notLinked: 'No product scope is linked to this ticket.',
      selectButton: 'Select',
      toast: {
        success: 'Product scope updated.'
      }
    },
    tabs: {
      history: 'History',
      overview: 'Overview',
      productScope: 'Product Scope'
    },
    topSections: {
      basicInfo: 'Basic Information',
      changeContent: 'Change Content',
      priorityRisk: 'Priority & Risk',
      productScope: 'Product Scope',
      progressDecision: 'Progress & Decision',
      qaImpact: 'QA Impact'
    }
  },
  externalIntegrations: {
    addIntegrationButton: 'Add Integration App',
    columns: {
      lastSyncedAt: 'Last Synced At',
      software: 'Software',
      syncResult: 'Sync Result',
      syncType: 'Sync Type'
    },
    connectButton: 'Connect',
    emptyDescription: "Please connect via 'Add Integration App' to register an external system",
    emptyTitle: 'No connected external systems',
    pageDescription: 'Asynchronously import and export development ticket data from external systems.',
    pageTitle: 'Data Integration with External Systems',
    reconnectButton: 'Reconnect',
    syncResult: {
      partialError: 'Partial Error',
      success: 'All Success'
    },
    tableHeader: 'Connected External Systems'
  },
  importCsv: {
    pageTitle: 'Bulk add development tickets via CSV',
    templateMessage: {
      completeLinkButton: 'Back to ticket list',
      templateTitle: 'Download template',
      updateExisting: 'Edit existing data'
    },
    unit: 'tickets'
  },
  list: {
    addTicket: 'Add Ticket',
    columns: {
      assignees: 'Assignees',
      code: 'Code',
      dueDate: 'Due Date',
      kind: 'Kind',
      priority: 'Priority',
      product: 'Product',
      status: 'Status',
      targetProduction: 'Target Production',
      title: 'Title'
    },
    filterPlaceholder: 'Search by title or code',
    filters: {
      priority: 'Priority',
      product: 'Product'
    },
    noResults: 'No tickets matched the current filter.',
    pageTitle: 'Development Tickets',
    tabLabel: 'Development Ticket List',
    tabs: {
      all: 'All',
      archived: 'Archive',
      closed: 'Closed',
      done: 'Done',
      inProgress: 'In Progress',
      inReview: 'In Review',
      open: 'Open'
    }
  }
};